module.exports = __webpack_public_path__ + "img/orgDetail_4.e035e9c8.png";